import React from 'react'
import Header from "components/Header";
import Sidebar from 'components/Sidebar';

const MainLayout = ({children}) => {
  return (
    <div>
      <div className='w-[309px] h-screen fixed bg-[#FFF] dark:bg-[#0F0F0F] hidden lg:flex'>
        <Sidebar/>
      </div>
      <div className='lg:ml-[309px]'>
        <Header/>
        {children}
      </div>
    </div>
  )
}

export default MainLayout
